import { useQuery } from '@tanstack/react-query'

import { identityServices } from '../identityServices'
import { QUERY_KEYS } from '@/constants/queryKeys'
import { useUserStore } from '@/store/useUserStore'

export const useGetBlockedUserList = () => {
  const myProfile = useUserStore((state) => state.userAuthenticated)

  return useQuery({
    queryKey: [QUERY_KEYS.IDENTITY_BLOCKED_USERS_LIST],
    queryFn: () =>
      identityServices.getBlockedUserList({ userID: myProfile!.user_id }),
    enabled: !!myProfile?.user_id,
  })
}
